import { getSnappedMousePosition } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/actions/utils/getSnappedMousePosition';
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Point } from '@/domain/dienstplan/features/VisualEditor/types';
import { STUNDEN_MAX } from '@/domain/dienstplan/shared/utils/constants';

export function updateCursorPosition({
  ctx,
  currentPoint,
}: {
  ctx: SharedContext;
  currentPoint: Point;
}) {
  const snappedPosition = getSnappedMousePosition(ctx, currentPoint);
  if (
    snappedPosition.y <= ctx.maxMitarbeiterAnzahl + 2 &&
    snappedPosition.y >= 0 &&
    snappedPosition.x >= 0 &&
    snappedPosition.x <= STUNDEN_MAX
  ) {
    ctx.store.setCursorPosition({
      x: ctx.xScalePoint(snappedPosition.x),
      y: ctx.yScalePoint(snappedPosition.y),
    });
  }
}
